//import { entries } from 'core-js/core/array';
import { async } from 'regenerator-runtime';
import { API_URL, RES_PER_PAGE, KEY } from './config';
//import { getJSON, sendJSON } from './helpers';
import { AJAX } from './helpers.js';

export const state = {
  recipe: {},
  search: {
    query: '',
    results: [],
    page: 1,
    resultsPerPage: RES_PER_PAGE,
    sorted: false,
  },
  bookmarks: [],
  shoppingList: [],
};

const createRecipeObject = function (data) {
  const { recipe } = data.data;

  return {
    id: recipe.id,
    title: recipe.title,
    publisher: recipe.publisher,
    sourceUrl: recipe.source_url,
    image: recipe.image_url,
    servings: recipe.servings,
    cookingTime: recipe.cooking_time,
    ingredients: recipe.ingredients,
    //trick to conditionaly add properties to an object
    ...(recipe.key && { key: recipe.key }),
  };
};

export const loadRecipe = async function (id) {
  try {
    const data = await AJAX(`${API_URL}${id}?key=${KEY}`);
    state.recipe = createRecipeObject(data);

    //checking if there is a recipe in the bookmarks array which is equal to the current recipe
    if (state.bookmarks.some(bookmark => bookmark.id === id))
      state.recipe.bookmarked = true;
    else state.recipe.bookmarked = false;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const loadSearchResults = async function (query) {
  try {
    state.search.query = query;

    const data = await AJAX(`${API_URL}?search=${query}&key=${KEY}`);

    state.search.results = data.data.recipes.map(rec => {
      return {
        id: rec.id,
        title: rec.title,
        publisher: rec.publisher,
        image: rec.image_url,
        //trick to conditionaly add properties to an object
        ...(rec.key && { key: rec.key }),
      };
    });

    //resetting the page number to 1 in each new search
    state.search.page = 1;

    //storing original search results in the state
    state.search.originalResults = [...state.search.results];
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const sortResults = function () {
  if (!state.search.results) return;

  //sorting rescipes by title in accending order
  //const originalResults = [...state.search.results];
  let sortedResults = [...state.search.results];
  sortedResults.sort((a, b) => {
    let titleA = a.title.toLowerCase(),
      titleB = b.title.toLowerCase();

    if (titleA < titleB) {
      return -1;
    }

    if (titleA > titleB) {
      return 1;
    }
  });

  //if sorted state is true then sort the results else keep original state
  state.search.sorted
    ? (state.search.results = sortedResults)
    : (state.search.results = state.search.originalResults);
};

export const getSearchResultsPage = function (page = state.search.page) {
  state.search.page = page;

  const start = (page - 1) * state.search.resultsPerPage; //0
  const end = page * state.search.resultsPerPage; //9
  return state.search.results.slice(start, end);
};

export const updateServings = function (newServings) {
  state.recipe.ingredients.forEach(ing => {
    //newQt = oldQt * newServings / oldServings // 2 * 8 / 4 = 4
    ing.quantity = (ing.quantity * newServings) / state.recipe.servings;
  });

  state.recipe.servings = newServings;
};

const persistBookmarks = function () {
  localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
};

export const addBookmark = function (recipe) {
  //Add bookmark
  state.bookmarks.push(recipe);

  //Mark current recipe as bookmark
  if (recipe.id === state.recipe.id) state.recipe.bookmarked = true;

  persistBookmarks();
};

export const deleteBookmark = function (id) {
  const index = state.bookmarks.findIndex(el => el.id === id);

  //splice(index where the element is located, how many items we want to delete)
  state.bookmarks.splice(index, 1);

  //unmark current recipe as bookmark
  if (id === state.recipe.id) state.recipe.bookmarked = false;

  persistBookmarks();
};

//getting data from local storage
const init = function () {
  const storageBookmark = localStorage.getItem('bookmarks');
  if (storageBookmark) state.bookmarks = JSON.parse(storageBookmark);

  const storageShoppingList = localStorage.getItem('shoppingList');
  if (storageShoppingList) state.shoppingList = JSON.parse(storageShoppingList);
};
init();

const clearBookmarks = function () {
  localStorage.clear('bookmarks');
};
//clearBookmarks();

export const uploadRecipe = async function (newRecipe) {
  try {
    //converting object to an array using entries method
    const ingredients = Object.entries(newRecipe)
      .filter(entry => entry[0].startsWith('ingredient') && entry[1] !== '')
      .map(ing => {
        //const ingArr = ing[1].replaceAll(' ', '').split(',');
        const ingArr = ing[1].split(',').map(el => el.trim());
        if (ingArr.length !== 3)
          throw new Error(
            'Wrong ingregient format! Please use the correct format :)'
          );
        const [quantity, unit, description] = ingArr;
        return { quantity: quantity ? +quantity : null, unit, description };
      });

    const recipe = {
      title: newRecipe.title,
      source_url: newRecipe.sourceUrl,
      image_url: newRecipe.image,
      publisher: newRecipe.publisher,
      cooking_time: +newRecipe.cookingTime,
      servings: +newRecipe.servings,
      ingredients,
    };
    const data = await AJAX(`${API_URL}?key=${KEY}`, recipe);
    state.recipe = createRecipeObject(data);
    addBookmark(state.recipe);
  } catch (err) {
    throw err;
  }
};

const persistShoppingList = function () {
  localStorage.setItem('shoppingList', JSON.stringify(state.shoppingList));
};

export const addToShoppingList = function () {
  try {
    if (state.shoppingList.some(el => el.id === state.recipe.id)) return -1;

    //adding recipe to shopping cart
    state.shoppingList.push(state.recipe);

    //adding recipe to bookmark
    persistShoppingList();
    if (state.shoppingList.length === 0) {
      throw new Error('Shopping List is Empty :)');
    }

    return state.shoppingList;
  } catch (err) {
    throw err;
  }
};

export const removeShoppingListItem = function (removeItemIndex) {
  try {
    //if (removeItemIndex ?? !removeItemIndex) return;

    //removing shopping list from shopping list
    state.shoppingList.splice(removeItemIndex, 1);

    //updating local storage
    persistShoppingList();
  } catch (err) {
    throw err;
  }
};
